import api from './api';
import { PaymentMethod } from '../types/types';

export const paymentMethodService = {
    // Get all payment methods
    getAllPaymentMethods: async (): Promise<PaymentMethod[]> => {
        const response = await api.get<PaymentMethod[]>('/paymentmethods');
        return response.data;
    },

    // Get payment method by ID
    getPaymentMethodById: async (id: number): Promise<PaymentMethod> => {
        const response = await api.get<PaymentMethod>(`/paymentmethods/${id}`);
        return response.data;
    },
};
